import React from "react";
import { WindowSizeInitializer } from "../common/layout/WindowSizeInitializer";

import { FetchRoleDescriptionsInitializer } from "./components/FetchRoleDescriptionsInitializer";
import { RequestResultsForPrintInitializer } from "./components/RequestResultsForPrintInitializer";
import { RequestSearchInitializer, RequestSearchInitializerProps } from "./components/RequestSearchInitializer";
import { SelectedChoicesInitializer } from "./components/SelectedChoicesInitializer";
import { ValidationInitializer } from "./components/ValidationInitializer";
import { DatesInitializer } from "./criteria/components/DatesInitializer";
import { ColumnsInitializer } from "./result/table/columns/ColumnsInitializer";
import { SearchScrollPositionInitializer } from "./SearchScrollPositionInitializer";
import { UrlValidator } from "./validator/UrlValidator";
import { ViewTrackerInitializer } from "./views/ViewTrackerInitializer";
import { columnsType } from "../common/types/search/results";
import { criteriaGroupsType } from "../common/types/search/search";

interface InitializersProps extends RequestSearchInitializerProps {
	columns?: columnsType;
	criteria: criteriaGroupsType;
	namespace: string;
}

export const Initializers = ({
	columns,
	criteria,
	namespace,
	...props
}: InitializersProps) => {
	return (
		<>
			<ColumnsInitializer columns={columns} />
			<DatesInitializer />
			<FetchRoleDescriptionsInitializer />
			<RequestResultsForPrintInitializer namespace={namespace} />
			<RequestSearchInitializer namespace={namespace} {...props} />
			<SearchScrollPositionInitializer namespace={namespace} />
			<SelectedChoicesInitializer criteria={criteria} />
			<ValidationInitializer criteria={criteria} />
			<ViewTrackerInitializer />
			<WindowSizeInitializer />
			<UrlValidator />
		</>
	);
};
